import isType from './is-type';

const isRegExp = function(str: any): str is RegExp {
  return isType(str, 'RegExp');
};

export default isRegExp;
